module.exports = __webpack_public_path__ + "static/media/nav-bg-palvelut.9f4f3dda.svg";